import React from 'react';

function GradientSVG() {
  const idCSS = 'hello';

  return (
    <svg style={{ height: 0 }}>
      <defs>
        <linearGradient id={idCSS} gradientTransform="rotate(90)">
          <stop offset="16.29%" stopColor="#613CCC" />
          <stop offset="85.56%" stopColor="#C86FE8" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default GradientSVG;
